/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetInventoryOutSummaryDetailsQuery } from '../../models/get-inventory-out-summary-details-query';
import { GetInventoryOutSummaryDetailsQueryResult } from '../../models/get-inventory-out-summary-details-query-result';

export interface ApiNurseryManagerReportsGetInvOutSummaryDetailsReportPost$Plain$Params {
      body?: GetInventoryOutSummaryDetailsQuery
}

export function apiNurseryManagerReportsGetInvOutSummaryDetailsReportPost$Plain(http: HttpClient, rootUrl: string, params?: ApiNurseryManagerReportsGetInvOutSummaryDetailsReportPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetInventoryOutSummaryDetailsQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiNurseryManagerReportsGetInvOutSummaryDetailsReportPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetInventoryOutSummaryDetailsQueryResult>;
    })
  );
}

apiNurseryManagerReportsGetInvOutSummaryDetailsReportPost$Plain.PATH = '/api/NurseryManager/Reports/GetInvOutSummaryDetailsReport';
